import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import {ExceededModal} from 'entities/user';
import {IPortMonitorListItem} from 'features/port/model/PortMonitor/IPortMonitor';
import {usePortMonitorResume} from 'features/port/model/usePortMonitorMutations';
import {getPortMonitorName} from 'features/port/lib/portMonitorHelper';

interface IPortMonitorResumeModalProps {
    item: IPortMonitorListItem,
    open: boolean,
    handleClose: () => void,
}

const PortMonitorResumeModal: React.FC<IPortMonitorResumeModalProps> = ({item, open, handleClose}) => {
    const {resume, isLoading, isExceededOpen, closeExceeded} = usePortMonitorResume({item, handleClose});

    return (
        <>
            <ConfirmModal
                variant="resume"
                open={open}
                handleClose={handleClose}
                header={t`Возобновление монитора порта`}
                title={
                    <Trans
                        id="modal.portMonitor.resume.title"
                        message="Вы уверены, что хотите возобновить монитор порта"
                    />
                }
                name={getPortMonitorName(item)}
                confirmText={t`Возобновить`}
                onConfirm={resume}
                isLoading={isLoading}
            />
            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeExceeded}
                type="port_monitors"
            />
        </>
    );
};

export default PortMonitorResumeModal;
